<template>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-sm-4">
        <h2>{{ title }}</h2>
        <ol class="breadcrumb">
          <li v-for="(piece,index) in pieces" :key="index">
            <a v-if="index != pieces.length - 1" href="javascript:void(0)">{{ piece }}</a>
            <strong v-if="index == pieces.length - 1">{{ piece }}</strong>
          </li>
        </ol>
      </div>
    </div>
</template>
<script>
export default {
    props: ['pieces', 'title']
}
</script>